export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/gaugeBlackIcon.25695a8d.svg","height":20,"width":24,"blurWidth":0,"blurHeight":0};